"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FetchRetryError extends Error {
    constructor(res) {
        super(res.statusText);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FetchRetryError);
        }
        this.res = res;
        this.name = this.constructor.name;
        this.url = res.url;
        this.statusCode = res.status;
    }
}
exports.default = FetchRetryError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmlsZTovLy9ob21lL2phcm1vL2dpdC90dXJpc3QtY2xvdWQvZmV0Y2gvc3JjL2ZldGNoLXJldHJ5LWVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsTUFBcUIsZUFBZ0IsU0FBUSxLQUFLO0lBS2pELFlBQVksR0FBYTtRQUN4QixLQUFLLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQyxDQUFDO1FBRXRCLElBQUksS0FBSyxDQUFDLGlCQUFpQixFQUFFO1lBQzVCLEtBQUssQ0FBQyxpQkFBaUIsQ0FBQyxJQUFJLEVBQUUsZUFBZSxDQUFDLENBQUM7U0FDL0M7UUFFRCxJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQztRQUNmLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUM7UUFDbEMsSUFBSSxDQUFDLEdBQUcsR0FBRyxHQUFHLENBQUMsR0FBRyxDQUFDO1FBQ25CLElBQUksQ0FBQyxVQUFVLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBQztJQUM5QixDQUFDO0NBQ0Q7QUFqQkQsa0NBaUJDIn0=